module.exports = __webpack_public_path__ + "static/media/36.508ae2ee.mp3";